import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { FabricDataService } from '../fabric-data.service';
import { getRouteForPermission } from '../models/dashboard.config';

/**
 * Default route guard that redirects users to the first dashboard they have permission to access
 * Priority is determined by the order of permissions in the API response
 */
export const DefaultRouteGuard = (): Observable<boolean | UrlTree> => {
  const fabricDataService = inject(FabricDataService);
  const router = inject(Router);

  return fabricDataService.getDashboardPermissions().pipe(
    map(permissions => {
      console.log('User permissions for default route:', permissions);
      
      // Find the first permission that has a corresponding route
      for (const permission of permissions) {
        const route = getRouteForPermission(permission);
        if (route) {
          console.log(`Redirecting to first available dashboard: ${route}`);
          return router.createUrlTree([route]);
        }
      }
      
      // If no valid permissions found, redirect to not-found
      console.warn('No valid dashboard permissions found, redirecting to not-found');
      return router.createUrlTree(['/not-found']);
    }),
    catchError(error => {
      console.error('Error determining default route:', error);
      // On error, redirect to not-found page
      return of(router.createUrlTree(['/not-found']));
    })
  );
};
